import { __decorate } from "tslib";
import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
let default_1 = class default_1 extends Vue {
    src;
    lazy;
    repeatKey = 0;
    onError() {
        if (this.repeatKey > 4)
            return;
        setTimeout(() => {
            this.repeatKey++;
        }, 100);
    }
    isBlur = localStorage.getItem('privacyMode') === 'true';
};
__decorate([
    Prop()
], default_1.prototype, "src", void 0);
__decorate([
    Prop({ default: false })
], default_1.prototype, "lazy", void 0);
__decorate([
    Emit('onError')
], default_1.prototype, "onError", null);
default_1 = __decorate([
    Component({
        name: '',
        components: {},
        i18n: {
            messages: {
                zh: {},
                en: {},
            },
        },
    })
], default_1);
export default default_1;
